import { Alert, CircularProgress } from "@mui/material";

interface Props {
  error?: unknown;
  loading: boolean;
}

export function renderErrorOrLoading({
  error,
  loading,
}: Props): JSX.Element | null {
  if (error) {
    return <Alert severity="error">Something went wrong</Alert>;
  }

  if (loading) {
    return <CircularProgress />;
  }

  return null;
}
